import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import { computed, watch } from 'vue';
import i18n from '@/i18n';

import type { SiffletButtonColor } from '@/components/SButton/SButton.vue';

interface DSModalProps {
  canSave: boolean,
  onSave?: () => void;
  onSaveAsync?: () => Promise<void>;
  onCancel?: () => void;
  onClose?: () => void;
  icon?: string;
  title: string,
  saveLabel?: string;
  saveColor?: SiffletButtonColor;
  saveIcon?: string | null;
  subtitle?: string,
  isBeta?: boolean,
  canCancel?: boolean,
  keepOpenOnSave?: boolean,
  width?: string,
  maxHeight?: string,
  hasSecondaryBackground?: boolean,
  removeDividers?: boolean,
  removeDividerTop?: boolean,
  removeDividerBottom?: boolean,
  // data-track attribute for testing purposes.
  dataTrack?: string,
  hasAction?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SModal',
  props: {
  canSave: { type: Boolean },
  onSave: { type: Function },
  onSaveAsync: { type: Function },
  onCancel: { type: Function },
  onClose: { type: Function },
  icon: null,
  title: null,
  saveLabel: { default: i18n.t('common.words.save') },
  saveColor: { default: 'primary' },
  saveIcon: { default: null },
  subtitle: null,
  isBeta: { type: Boolean, default: false },
  canCancel: { type: Boolean, default: true },
  keepOpenOnSave: { type: Boolean, default: false },
  width: { default: '900' },
  maxHeight: null,
  hasSecondaryBackground: { type: Boolean, default: false },
  removeDividers: { type: Boolean, default: false },
  removeDividerTop: { type: Boolean, default: false },
  removeDividerBottom: { type: Boolean, default: false },
  dataTrack: null,
  hasAction: { type: Boolean, default: true }
},
  emits: ['modalToggle'],
  setup(__props, { expose, emit }) {

const props = __props;




let isOpened = _ref(false);
const extraClass = computed(() => (props.hasSecondaryBackground ? 'bg-secondary' : ''));
const maxHeight = computed(() => (props.maxHeight ? `${props.maxHeight}px` : 'auto'));
const showTopDivider = computed(() => !(props.removeDividers || props.removeDividerTop));
const showBottomDivider = computed(() => !(props.removeDividers || props.removeDividerBottom));

const closeModal = () => isOpened.value = false;

const openModal = () => isOpened.value = true;

const handleCancel = () => {
  props.onCancel?.();
  closeModal();
};

const handleSave = () => {
  props.onSave?.();

  if (!props.keepOpenOnSave) {
    closeModal();
  }
};

const handleSaveAsync = async () => {
  await props.onSaveAsync?.();

  if (!props.keepOpenOnSave) {
    closeModal();
  }
};

watch(() => isOpened.value, () => {
  emit('modalToggle', isOpened.value);

  if (!isOpened.value) {
    props.onClose?.();
  }
});

expose({ openModal, closeModal, isOpened: isOpened.value });

return { __sfc: true,props, emit, isOpened, extraClass, maxHeight, showTopDivider, showBottomDivider, closeModal, openModal, handleCancel, handleSave, handleSaveAsync, _ref, computed, watch, i18n }
}

})